/** @format */

import moment from 'moment';

// 按时计费
export interface IByTimeMainForm {
  id: string;
  includedFreeTime: string; // 计费是否包含免费时间
  isUseCompleteUnit: string; // 不足计费单位是否补足
  isReBillingOverTwentyFour: string; // 超过24小时是否重新计费
  afterFreeTime: number; // 付费后规定出场时间(分钟)
  freeTime: number; // 免费分钟
  startChargeTime: number; // 起步时段(分钟)
  startChargeMoney: number; // 起步时段（元）
  topMoneyOfTwentyFour: number; // 24小时限额(0为不限额)
  cycleChargeTime: number; // 循环时段(分钟)
  cycleChargeMoney: number; // 循环时段(元)
  limitMode: string; // 请选择限额模式(不限首次)
  topMoney: string; // 最多收费金额
  isContinueTwentyFour?: string;
  limitMoneyOfDefines: any[];
  overNightFee: number;
  oneOrMoreOverNightFee: string;
}
export const byTimeMainFormDefault = {
  id: '',
  includedFreeTime: '0',
  isUseCompleteUnit: '0',
  isReBillingOverTwentyFour: '0',
  afterFreeTime: 0,
  freeTime: 0,
  startChargeTime: 0,
  startChargeMoney: 0,
  topMoneyOfTwentyFour: 0,
  cycleChargeTime: 0,
  cycleChargeMoney: 0,
  limitMode: '0',
  topMoney: '',
  isContinueTwentyFour: '0', // 未使用
  limitMoneyOfDefines: [
    {
      limitTime: 0,
      money: 0
    }
  ],
  overNightFee: 0,
  oneOrMoreOverNightFee: '0'
};

export interface IByTimeBackUpForm {
  id1: string;
  includedFreeTime1: string;
  isUseCompleteUnit1: string;
  isReBillingOverTwentyFour1: string;
  afterFreeTime1: number;
  freeTime1: number;
  startChargeTime1: number;
  startChargeMoney1: number;
  topMoneyOfTwentyFour1: number;
  cycleChargeTime1: number;
  cycleChargeMoney1: number;
  limitMode1: string;
  topMoney1: string;
  isContinueTwentyFour1?: string;
  limitMoneyOfDefines: any[];
  overNightFee: number;
  oneOrMoreOverNightFee: string;
}
export const byTimeBackUpFormDefault = {
  id1: '',
  includedFreeTime1: '0',
  isUseCompleteUnit1: '0',
  isReBillingOverTwentyFour1: '0',
  afterFreeTime1: 0,
  freeTime1: 0,
  startChargeTime1: 0,
  startChargeMoney1: 0,
  topMoneyOfTwentyFour1: 0,
  cycleChargeTime1: 0,
  cycleChargeMoney1: 0,
  limitMode1: '0',
  topMoney1: '',
  isContinueTwentyFour1: '0', // 未使用
  limitMoneyOfDefines: [
    {
      limitTime: 0,
      money: 0
    }
  ]
  // overNightFee: 0,
  // oneOrMoreOverNightFee: '0',
};

// 按次计费
export interface IOnTimesForm {
  id: string;
  includedFreeTime: string; // 计费是否包含免费时间
  afterFreeTime: number; // 付费后规定出场时间(分钟)
  freeTime: number; // 免费分钟
  moneyOnCycle: number; // 周期收费金额(元)
  topCount: number; // 最高周期次数
  startHour: number; // 周期开始时间(小时)
  startMinutes: number; // 周期开始时间(分钟)
  endHour: number; // 周期结束时间(小时)
  endMinutes: number; // 周期结束时间(分钟)
  limitMode: string; // 请选择限额模式(不限首次)
  topMoney: string; // 最多收费金额
  limitMoneyOfDefines: any[];
  overNightFee?: number;
  oneOrMoreOverNightFee?: string;
}

export const onTimesFormDefault = {
  id: '',
  includedFreeTime: '0',
  afterFreeTime: 0,
  freeTime: 0,
  moneyOnCycle: 0,
  topCount: 0,
  startHour: 0,
  startMinutes: 0,
  endHour: 0,
  endMinutes: 0,
  limitMode: '0',
  topMoney: '0',
  limitMoneyOfDefines: [
    {
      limitTime: 0,
      money: 0
    }
  ]
  // overNightFee: 0,
  // oneOrMoreOverNightFee: '0',
};

// 分段计费
export interface IOnSeparateForm {
  id: string;
  includedFreeTime: string; // 计费是否包含免费时间
  isReStartInDefferentPeriod: string; // 跨段是否重新起步
  topMoneyOfTwentyFour: number; // 24小时最高收费(元,0为不限额)
  afterFreeTime: number; // 付费后规定出场时间(分钟)
  isUseCompleteUnit: string; // 不足计费单位是否补足
  isJustUseStartRule: string; // 是否仅使用开始时间的规则
  limitMode: string; // 请选择限额模式(不限首次)
  topMoney: string; // 最多收费金额
  isContinueTwentyFour?: string;
  onceTopMoney: number;
  limitMoneyOfDefines: any[];
  overNightFee?: number;
  oneOrMoreOverNightFee?: string;
}

export const onSeparateFormDefault = {
  id: '',
  includedFreeTime: '0',
  isReStartInDefferentPeriod: '0',
  topMoneyOfTwentyFour: 0,
  afterFreeTime: 0,
  isUseCompleteUnit: '0',
  isJustUseStartRule: '0',
  limitMode: '0',
  topMoney: '',
  isContinueTwentyFour: '0', // 未使用
  limitMoneyOfDefines: [
    {
      limitTime: 0,
      money: 0
    }
  ],
  // overNightFee: 0,
  // oneOrMoreOverNightFee: '0',
  onceTopMoney: 0
};

export interface IOnSeparateFormArr {
  startTime: any; // 起始时间
  endTime: any; // 结束时间
  startChargeTime: number; // 起步时段(分钟)
  startChargeMoney: number; // 起步时段(元)
  freeTime: number; // 免费分钟
  topMoneyOfSection: number; // 每段限额
  cycleChargeTime: number; // 循环时段(分钟)
  cycleChargeMoney: number; // 循环时段(元)
  limitMoneyOfDefines: any[];
  overNightFee?: number;
  oneOrMoreOverNightFee?: string;
}

export const onSeparateFormArrDefault = [
  {
    startTime: '',
    endTime: '',
    startChargeTime: 0,
    startChargeMoney: 0,
    freeTime: 0,
    topMoneyOfSection: 0,
    cycleChargeTime: 0,
    cycleChargeMoney: 0,
    limitMoneyOfDefines: [
      {
        limitTime: 0,
        money: 0
      }
    ]
    // overNightFee: 0,
    // oneOrMoreOverNightFee: '0',
  }
];

// 分时计费
export interface IOnShareTimeForm {
  id: string;
  freeTime: number; // 免费分钟
  includedFreeTime: string; // 计费是否包含免费时间
  afterFreeTime: number; // 付费后规定出场时间(分钟)
  limitMode: string; // 请选择限额模式(不限首次)
  topMoney: string; // 最多收费金额
  hour: number; // 周期循环(小时)
  minutes: number; // 周期循环(分钟)
  cycleMoney: number; // 周期循环(元)
  topMoneyOfTwentyFour: number; // 24小时最高收费(元,0为不限额)
  isContinueTwentyFour?: string;
  limitMoneyOfDefines: any[];
  overNightFee?: number;
  oneOrMoreOverNightFee?: string;
}

export const onShareTimeFormDefault = {
  id: '',
  freeTime: 0,
  includedFreeTime: '0',
  afterFreeTime: 0,
  limitMode: '0',
  topMoney: '0',
  hour: 0,
  minutes: 0,
  cycleMoney: 0,
  topMoneyOfTwentyFour: 0,
  isContinueTwentyFour: '0', // 未使用
  limitMoneyOfDefines: [
    {
      limitTime: 0,
      money: 0
    }
  ]
  // overNightFee: 0,
  // oneOrMoreOverNightFee: '0',
};

export interface IOnShareTimeFormArr {
  hour: number | string; // 时长(小时)
  minutes: number; // 时长(分钟)
  money: number; // 时长(元)
}

// 新按时计费
export interface IOnOnceForm {
  getmoreflag: boolean;
  moreflag: boolean;
  billingOnFreeTimes: any[];
  id: string;
  freeTime: any; // 免费分钟
  includedFreeTime: any; // 计费是否包含免费分钟(分钟)
  topMoneyOfTwentyFour: any; // 24小时限额（0为不限额）
  freeTimes: any; // 免收时长
  freeCounts: any; // 自然日内免收时长享受次数
  isUseCompleteUnit: any; // 不足计费单位默认补足
  isReBillingOverTwentyFour: any; // 超24小时重新执行【起步时段】规则
  overNightFee: any; // 跨0点收取过夜费
  oneOrMoreOverNightFee: any; // 同一笔订单，多日跨0点只收一次过夜费
  limitMode: any; // 请选择限额模式(不限首次)
  limitTime: any; //请填写自定义时长
  topMoney: any; // 最多收费金额
  isPremiumRateSwitch: any; //打开阶梯费率
  isPremiumFenSwitch: any; //打开分段计费
  startChargeTime: any;
  limitMoneyOfDefines: any;
  startChargeMoney: any;
  cycleChargeTime: any;
  cycleChargeMoney: any;
  cycleChargeRateTime: any;
  cycleChargeRateMoney: any;
  isJustUseStartRule: any;
  isLimitSeparate: any;
  onceTopMoney: any;
  rules: any[];
  money: any;
}

export const normalForm = {
  id: '',
  freeTime: 0, // 免费分钟
  includedFreeTime: '0', // 计费是否包含免费分钟(分钟)
  topMoneyOfTwentyFour: 0, // 24小时限额（0为不限额）
  freeTimes: 0, // 免收时长
  freeCounts: 0, // 自然日内免收时长享受次数
  isUseCompleteUnit: '0', // 不足计费单位默认补足
  isReBillingOverTwentyFour: '0', // 超24小时重新执行【起步时段】规则
  overNightFee: 0, // 跨0点收取过夜费
  oneOrMoreOverNightFee: '0', // 同一笔订单，多日跨0点只收一次过夜费
  limitMode: '0', // 请选择限额模式(不限首次)
  limitTime: '0', //请填写自定义时长
  topMoney: '0', // 最多收费金额
  isPremiumRateSwitch: '0', //打开阶梯费率
  isPremiumFenSwitch: '0', //打开分段计费
  billingOnFreeTimes: [],
  limitMoneyOfDefines: [
    {
      limitTime: '0',
      money: '0'
    }
  ],
  startChargeTime: 0,
  startChargeMoney: 0,
  cycleChargeTime: 0,
  cycleChargeMoney: 0,
  cycleChargeRateTime: 0,
  cycleChargeRateMoney: 0,
  isJustUseStartRule: '0',
  isLimitSeparate: '0',
  onceTopMoney: 0,
  rules: [
    {
      startTime: moment('00:00', 'HH:mm'),
      endTime: moment('00:00', 'HH:mm'),
      freeTime: 0,
      includedFreeTime: '0',
      topMoneyOfSection: 0,
      isPremiumRateSwitch: '0',
      startChargeTime: 0,
      startChargeMoney: 0,
      cycleChargeTime: 0,
      cycleChargeMoney: 0,
      cycleChargeRateTime: 0,
      cycleChargeRateMoney: 0,
      billingOnFreeTimes: []
    },
    {
      startTime: moment('00:00', 'HH:mm'),
      endTime: moment('00:00', 'HH:mm'),
      freeTime: 0,
      includedFreeTime: '0',
      topMoneyOfSection: 0,
      isPremiumRateSwitch: '0',
      startChargeTime: 0,
      startChargeMoney: 0,
      cycleChargeTime: 0,
      cycleChargeMoney: 0,
      cycleChargeRateTime: 0,
      cycleChargeRateMoney: 0,
      billingOnFreeTimes: []
    }
  ]
};

// 新按时计费
export interface IOnOnceForm {
  getmoreflag: boolean;
  moreflag: boolean;
  billingOnFreeTimes: any[];
  id: string;
  freeTime: any; // 免费分钟
  includedFreeTime: any; // 计费是否包含免费分钟(分钟)
  topMoneyOfTwentyFour: any; // 24小时限额（0为不限额）
  freeTimes: any; // 免收时长
  freeCounts: any; // 自然日内免收时长享受次数
  isUseCompleteUnit: any; // 不足计费单位默认补足
  isReBillingOverTwentyFour: any; // 超24小时重新执行【起步时段】规则
  overNightFee: any; // 跨0点收取过夜费
  oneOrMoreOverNightFee: any; // 同一笔订单，多日跨0点只收一次过夜费
  limitMode: any; // 请选择限额模式(不限首次)
  limitTime: any; //请填写自定义时长
  topMoney: any; // 最多收费金额
  isPremiumRateSwitch: any; //打开阶梯费率
  isPremiumFenSwitch: any; //打开分段计费
  startChargeTime: any;
  limitMoneyOfDefines: any;
  startChargeMoney: any;
  cycleChargeTime: any;
  cycleChargeMoney: any;
  cycleChargeRateTime: any;
  cycleChargeRateMoney: any;
  isJustUseStartRule: any;
  isLimitSeparate: any;
  onceTopMoney: any;
  rules: any[];
  money: any;
}

export const onShareTimeFormArrDefault = [{ hour: '', minutes: 0, money: 0 }];
